import { render, staticRenderFns } from "./items-type-rr.vue?vue&type=template&id=31330f96&scoped=true"
import script from "./items-type-rr.vue?vue&type=script&lang=js"
export * from "./items-type-rr.vue?vue&type=script&lang=js"
import style0 from "./items-type-rr.vue?vue&type=style&index=0&id=31330f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31330f96",
  null
  
)

export default component.exports